import request from '@/api/request.js'

/** 2026-09-11：物理图片文件、引用分类和垃圾回收任务接口。 */
const imageFile = {
  statistics: () => request({ url: '/admin_image_file/statistics', method: 'GET' }),
  list: params => request({ url: '/admin_image_file/index', method: 'GET', params }),
  details: params => request({ url: '/admin_image_file/details', method: 'GET', params }),
  queueCleanup: data => request({ url: '/admin_image_file/queueCleanup', method: 'POST', data }),
  purgeNow: data => request({ url: '/admin_image_file/purgeNow', method: 'POST', data }),
  retry: data => request({ url: '/admin_image_file/retry', method: 'POST', data }),
  cancel: data => request({ url: '/admin_image_file/cancel', method: 'POST', data })
}

export default imageFile
